export type ImageTemplateProps = {
  imgSrc: string;
};

export const ImageTemplate = ({ imgSrc }: ImageTemplateProps): JSX.Element => (
  <img src={imgSrc} className="block w-full h-full object-cover" />
);
